import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFoundPage = () => <Container maxWidth="sm"><Box minHeight="80vh" display="grid" sx={{ placeItems: 'center', textAlign: 'center' }}><Box><Typography variant="h1" color="primary">404</Typography><Typography variant="h4" mb={3}>Такой страницы нет</Typography><Button component={Link} to="/" variant="contained">На главную</Button></Box></Box></Container>;
export default NotFoundPage;
